import type { ReactElement } from 'react'

import { FlowPage } from '@monthio/design-system'
import { PensionsinfoStart } from '@monthio/icons'
import { ListItem, ListItemText, OrderedList } from '#components/OrderedList'
import { useTranslation } from 'react-i18next'

export const PensionIntro = (): ReactElement => {
	const { t } = useTranslation()

	return (
		<>
			<FlowPage.Header
				slot={<PensionsinfoStart width={250} />}
				title={t('pensionPage-title')}
				description={t('pensionPage-subtitle')}
			/>
			<OrderedList compact>
				<ListItem>
					<ListItemText compact>{t('pensionPage-openPopup-txt')}</ListItemText>
				</ListItem>
				<ListItem>
					<ListItemText compact>{t('pensionPage-redirect-txt')}</ListItemText>
				</ListItem>
			</OrderedList>
		</>
	)
}
